(function () {
  'use strict';
  var data = window.PGSocialProofRecentDataV3;
  if (!data || !Array.isArray(data.recent)) {
    window.PGSocialProofRecentDataV3 = { generatedAt: null, sourceWindowHours: 48, recent: [] };
    return;
  }
  var cutoff = Date.now() - (48 * 60 * 60 * 1000);
  data.recent = data.recent.filter(function (entry) {
    var orderedAt = Date.parse((entry && entry.orderedAt) || '');
    return Number.isFinite(orderedAt) && orderedAt >= cutoff;
  }).sort(function (a, b) {
    return Date.parse(b.orderedAt) - Date.parse(a.orderedAt);
  });
  data.sourceWindowHours = 48;
})();